import React from 'react';
export function Footer() {
  return <footer className="border-t border-navy-line bg-navy-deep px-3 py-3 text-center sm:px-6" data-id="element-71" data-mp="32wd2qgad7ltj">
      <p className="text-[0.66rem] font-semibold text-white/85 sm:text-[0.76rem]" data-id="element-72" data-mp="3ggtwodvnbb34">
        © 2026 POOL &amp; SPA DIAGNOSTIC PRO™ — All Rights Reserved.
      </p>
      <p className="mx-auto mt-1 max-w-2xl text-[0.62rem] leading-[1.45] text-white/60 sm:text-[0.72rem]" data-id="element-73" data-mp="36oxwmxa01aw9">
        POOL &amp; SPA DIAGNOSTIC PRO™ is an educational and professional reference resource. It does not
        guarantee successful repairs or replace applicable safety regulations, manufacturer instructions,
        required professional qualifications, specialized electrical, gas or refrigeration procedures,
        professional training or qualified technical judgment.
      </p>
      <p className="mt-1 text-[0.62rem] text-white/60 sm:text-[0.72rem]" data-id="element-74" data-mp="29ynldknsn5e0">
        <a href="#" className="transition-colors duration-150 ease-out hover:text-aqua" data-id="element-75" data-mp="2eya05yj9stox">
          Terms &amp; Conditions
        </a>{' '}
        •{' '}
        <a href="#" className="transition-colors duration-150 ease-out hover:text-aqua" data-id="element-76" data-mp="3labrlvxno6qd">
          Privacy Policy
        </a>{' '}
        •{' '}
        <a href="mailto:kitonline27@gmail.com" className="transition-colors duration-150 ease-out hover:text-aqua" data-id="element-77" data-mp="3v7q5bns72hez">
          Contact
        </a>
      </p>
      <p className="mt-0.5 text-[0.62rem] text-white/60 sm:text-[0.72rem]" data-id="element-78" data-mp="3q7ty7fo7a9v7">
        Support:{' '}
        <a href="mailto:kitonline27@gmail.com" className="transition-colors duration-150 ease-out hover:text-aqua" data-id="element-79" data-mp="81pddd69wn6q">
          kitonline27@gmail.com
        </a>
      </p>
    </footer>;
}